export default __webpack_public_path__ + "static/media/2432.fd5de3c6.png";